export default {
  balances: 'Balansai',
  name: 'Vardas',
  balance: 'Balansas',
  createdAt: 'Data ir Laikas ({tzOffset})',
  authoredBy: 'Patvirtino',
  newDeposit: 'Naujas Įnašas',
  dialogConfirmationMessage: 'Šis veiksmas automatiškai išjungs "Užsakymas be depozito" parinktį šiam vartotojui, tęsti?',
  totalCityBalance: 'Balansas {city}: {amount}',
};
